import React from 'react';
import PartnerDemoPage from 'pages/PartnerPage/PartnerDemoPage';

const PartnerDemo = () => {
  return (
    <PartnerDemoPage/>
  );
};

export default PartnerDemo;